import { FC } from 'react';

import s from './InfoBlock.module.scss';

interface IInfoBlockProps {
  title: string;
  data: string;
  secondaryData?: string;
  showPlaceholder: boolean;
}
export const InfoBlock: FC<IInfoBlockProps> = ({
  data,
  secondaryData,
  title,
  showPlaceholder,
}) => {
  return (
    <div className={s.container}>
      <div className={s.data}>
        {showPlaceholder ? '—' : data}
        {!showPlaceholder && Boolean(secondaryData) && (
          <span className={s.secondary}>{secondaryData}</span>
        )}
      </div>
      <span className={s.title}>{title}</span>
    </div>
  );
};
